// ScrollToTop.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Links like /team#advisors scroll to that section instead of the top
    if (hash) {
      let timer;
      const scrollToHash = () => {
        timer = setTimeout(() => {
          const element = document.getElementById(hash.slice(1));
          if (element) element.scrollIntoView({ behavior: "smooth" });
        }, 100);
      };
      // On a fresh page load, wait until images have loaded so the
      // section is in its final position before scrolling to it
      if (document.readyState === "complete") scrollToHash();
      else window.addEventListener("load", scrollToHash, { once: true });
      return () => {
        clearTimeout(timer);
        window.removeEventListener("load", scrollToHash);
      };
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
